export default class loader{
 mainLoaderClass: string = "meme-loader";
 on: any = {
  hide: new CustomEvent('onHideLoader')
 };
 constructor(){
  document.body.classList.add("meme-loading")
 }

 hide(){
  document.body.classList.remove('meme-loading')
  document.querySelector(`.${this.mainLoaderClass}`)?.classList.add(`${this.mainLoaderClass}--hide`)
  setTimeout(()=>{
   window.dispatchEvent(this.on.hide)
  }, 200)
 }
}